import { SvgIcon, type SvgIconProps } from '../layout/SvgIcon';

export const PlusGradient = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 14 14" {...props}>
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.593131 6.92047C0.593131 6.50626 0.928917 6.17047 1.34313 6.17047L6.24998 6.17047L6.24999 1.26362C6.24999 0.849403 6.58577 0.513617 6.99999 0.513617C7.4142 0.513616 7.74999 0.849403 7.74999 1.26362L7.74999 6.17047L12.6568 6.17047C13.0711 6.17047 13.4068 6.50626 13.4068 6.92047C13.4068 7.33468 13.0711 7.67047 12.6568 7.67047L7.74999 7.67047L7.74999 12.5773C7.74998 12.9915 7.4142 13.3273 6.99999 13.3273C6.58577 13.3273 6.24998 12.9915 6.24998 12.5773L6.24998 7.67047L1.34313 7.67047C0.928917 7.67047 0.593131 7.33468 0.593131 6.92047Z"
                fill="url(#paint0_linear_2013_642)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2013_642"
                    x1="6.99999"
                    y1="13.638"
                    x2="16.5164"
                    y2="1.79556"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9900CC" />
                    <stop offset="1" stopColor="#153BFF" />
                </linearGradient>
            </defs>
        </svg>
    </SvgIcon>
);
